<template>
  <div class="task" v-if="task" :class="{ 'group-task' : task.group_task, 'with-hours' : (taskProject && taskProject.est_hours > 0) }">
    <el-container>
      <el-header height="100px" class="with-tags">
        <h2 class="card-title" @click="editSelectedTask">
          <client-code v-if="!task.client_icon_url" :code="task.client_code" :seed="task.client_name"/>
          <img v-if="task.client_icon_url" :src="task.client_icon_url" class="client-code"/>
          {{ task.title }}
          <i class="el-icon-edit-outline"></i>
        </h2>
        <project-hours-tags v-if="taskProject && taskProject.est_hours > 0" :project="taskProject" size="small" />
        <div class="tags">

          <el-tag type="success" size="small"><icon name="regular/clock" /> {{ secondsToTime(task.total_time) }}</el-tag>
          <el-tag :type="taskStatusClass" size="small">{{ statuses[task.status] }}</el-tag>
          <router-link v-if="!task.group_task" :to="{ name: 'user', params: { user_id: task.user_id }}">
            <el-tag type="warning" size="small"><icon name="user" /> {{ task.user_full_name }}</el-tag>
          </router-link>
          <el-tag type="warning" v-if="task.group_task" size="small"><icon name="user" /> {{ task.user_full_name }}</el-tag>
          <router-link :to="{ name: 'project', params: { project_id: task.project_id }}">
            <el-tag size="small"><icon name="desktop" /> {{ task.project_name }}</el-tag>
          </router-link>
          <router-link :to="{ name: 'client', params: { client_id: task.client_id }}">
            <el-tag size="small"><icon name="book" /> {{ task.client_name }}</el-tag>
          </router-link>
          <project-avatars v-if="task.group_task" :task="task" />
        </div>
      </el-header>
      <el-main class="panels">
        <task-timer class="panel-right" :task="task" v-if="task" />
        <log-list class="panel-left"
                  :show-project-title="false"
                  :show-task-title="false"
                  :logs="taskLogs"
                  v-if="task" />
      </el-main>
    </el-container>

    <task-crud :task="task"
               v-if="showTaskCrud"
               @close="taskCrudClose" />
  </div>
</template>

<script>
  import { mixin as LogTimes } from '../../mixins/LogTimes'
  import { mixin as Utils } from '../../mixins/Utils'
  import { taskStatuses } from '../../util/taskStatuses'

  export default {
    name: 'task',
    mixins: [LogTimes, Utils],
    data () {
      return {
        task: null,
        showTaskCrud: false
      }
    },
    methods: {
      editSelectedTask () {
        this.showTaskCrud = true
      },
      handleRouteParamTaskId () {
        this.task = this.tasks[this.routeParamTaskId]
      },
      taskCrudClose (task) {
        // Handle the Task Crud Dialog closing
        this.showTaskCrud = false
        if (task) {
          // Refresh the task that has been updated
          this.task = this.tasks[task.id]
        }
      },
      setPageTitle () {
        if (this.task) {
          this.$store.dispatch('setPageTitle', 'Projects | ' + this.task.project_code)
        }
      },
      gotoProject () {
        this.$router.push({name: 'project', params: {project_id: this.task.project_id}})
      },
      gotoUser (userId) {
        this.$router.push({name: 'user', params: {user_id: userId}})
      }
    },
    computed: {
      currentUser () {
        return this.$store.state.users.currentUser
      },
      taskProject () {
        return this.$store.state.projects.objects[this.task.project_id]
      },
      taskLogs () {
        var logs = []
        if (this.task) {
          logs = Object.keys(this.logs).map((k) => this.logs[k]).filter(function (item) {
            return item.task_id === this.task.id
          }.bind(this))
        }
        return logs
      },
      statuses () {
        return taskStatuses
      },

      // Vuex Mappings
      tasks () {
        return this.$store.state.tasks.objects
      },
      logs () {
        return this.$store.state.logs.objects
      },
      // Vue Router Params
      routeParamTaskId () {
        return this.$route.params.task_id
      },
      taskStatusClass () {
        switch (this.task.status) {
          case 0:
            return ''
          case 1:
            return 'success'
          case 2:
          case 3:
            return 'warning'
          case 4:
          case 5:
          case 6:
            return 'warning'
          default:
            return ''
        }
      }
    },
    created () {
      this.handleRouteParamTaskId()
    },
    mounted () {
      // Note: Intentionally not calling store.getUsers as this is handled on load in App.vue
      // and Pusher should take care of live-updates to users
      this.$store.dispatch('setPageTitle', 'Tasks')
      this.$store.dispatch('getTask', this.routeParamTaskId)
      this.$store.dispatch('getLogs', { 'task_id': this.routeParamTaskId })
    },
    watch: {
      'tasks' () {
        this.setPageTitle()
        this.handleRouteParamTaskId()
      },
      // When the route is programatically changed (e.g. when a different task is selected)
      // the route 'task_id' param (this.taskId) will change.
      // Re-init the Component's data when this happens
      'task' () {
        this.setPageTitle()
        this.handleRouteParamTaskId()
        if (this.task) {
          // Attempt to clear any notifications for the task
          this.$store.dispatch('clearTaskNotifications', this.task)
        }
      },
      // If a user manually changes the route, force update the Component's data
      '$route' () {
        this.handleRouteParamTaskId()
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .card-title {
    cursor: pointer;
  }
  .task {
    &.group-task .el-main {
      max-height: ~'calc(100vh - 210px)';
    }
    &.with-hours .el-main {
      max-height: ~'calc(100vh - 200px)';
    }
    &.group-task.with-hours .el-main {
      max-height: ~'calc(100vh - 240px)';
    }
  }
</style>
